module.exports = __webpack_public_path__ + "static/img/billy_300x300.ac07723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billy_300x300.jpg
// module id = TW+m
// module chunks = 1